import React from 'react';
import { CTAButton, TrustLine } from './CTAButton';
import { BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function Hero() {
  return <header className="bg-petrol px-4 pb-6 pt-5 text-center sm:px-6" data-id="element-76" data-mp="eilc6zjmglae">
      <p className="font-heading text-[0.65rem] font-bold uppercase tracking-[0.18em] text-gold sm:text-xs" data-id="element-77" data-mp="9ll9mylze0o1">
        Complete 6-in-1 System · Instant Digital Access
      </p>
      <h1 className="mt-2 font-heading text-[1.55rem] font-extrabold uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-78" data-mp="12a0l5b5wm0um">
        The Complete Daily Care Organization System
      </h1>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-cream/90 sm:text-base" data-id="element-79" data-mp="sb1axo5hpx5i">
        Stop planning every care day from scratch. Access ready-to-use planners,
        routines, trackers, care notes, safety tools, handoff sheets and
        communication resources. Keep everyday care responsibilities organized in
        one professional system.
      </p>
      <p className="mt-2 font-heading text-sm font-bold uppercase text-sage sm:text-base" data-id="element-80" data-mp="384js0vnybdrc">
        Less time organizing. More structure for every care day.
      </p>

      <a href={PURCHASE_ANCHOR} className="mt-4 block" data-id="element-81" data-mp="3o6ap3tgx82yw">
        <img src={BOX_IMAGE} alt="CAREGIVER READY™ complete 6-in-1 care organization system box set" className="mx-auto w-full max-w-[340px] drop-shadow-2xl sm:max-w-md" data-id="element-82" data-mp="39acuifmnb6os" />
      </a>

      <div className="mx-auto mt-4 max-w-md" data-id="element-83" data-mp="30hhsrvwdzt3r">
        <CTAButton label="💙 Yes! I want the complete system" className="!bg-gold !text-deep !shadow-[0_8px_0_0_#A5854D]" data-id="element-84" data-mp="30gq5d8cy11ok" />
        <TrustLine className="mt-3 !text-cream/85" data-id="element-85" data-mp="2qkmrx6cn5gmb" />
      </div>
    </header>;
}